/**
 * Work time is entered as a duration in hours (e.g. `1.1234`), capped at four decimal places.
 * Legacy records written by the previous time picker hold values such as `0.3333333333333333`
 * (20 minutes), so they have to be rounded to this precision before the input can show them.
 */
export const WORK_TIME_DECIMAL_PLACES = 4;
